<app-breadcrumbs class="mb-3" [lastLabel]="'Dettaglio Job Schedule: ' + (name ?? '')"></app-breadcrumbs>

<mat-card class="mat-elevation-z8 container-card">
    <mat-card-content class="mat-elevation-z8">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChanged($event)">


            <mat-tab label="{{sitemapOrUrlTabName}}">
                <app-shared-table [dataSource]="dataSourceUrls" [nameTable]="'crawling-web-urls-detail'" (toolbarAction)="exportUrls($event)" [displayedColumns]="['url', 'actions']" [columnLabels]="{url: sitemapOrUrlTabName}" [notAllowAdd]="sitemapOrUrlTabName === 'Sitemap' ? true : false" (openModal)="openDialog($event)" [length]="urlsTotalItems" [pageSize]="urlsPageSize" [pageIndex]="urlsPageIndex" (pageChanged)="onUrlPageChanged($event)" [isLoading]="isLoading" [isSortable]="false"></app-shared-table>
            </mat-tab>

            <mat-tab label="Schedulazione">
                <app-shared-table [dataSource]="dataSourceSchedules" [nameTable]="'crawling-web-schedules-detail'" [displayedColumns]="['selectDay', 'selectMinute', 'selectHour', 'actions']" [columnLabels]="{selectDay: 'Inizia ad eseguire la scansione il:', selectHour: 'Ora Inizio', selectMinute: 'Minuto Inizio'}" (openModal)="openDialog($event)" [length]="triggerTotalItems" [pageSize]="triggerPageSize" [pageIndex]="triggerPageIndex" (pageChanged)="onTriggerPageChanged($event)" [isLoading]="isLoading" [isSortable]="false"></app-shared-table>
            </mat-tab>

        </mat-tab-group>
    </mat-card-content>
</mat-card>
